import { render, staticRenderFns } from "./ClientReservationChooseSlot.vue?vue&type=template&id=63879db4"
import script from "./ClientReservationChooseSlot.vue?vue&type=script&lang=js"
export * from "./ClientReservationChooseSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports